var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cf54bb40fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.21875 21 L 142.96875 21 L 142.96875 150 L 7.21875 150 Z M 7.21875 21 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf54bb40fe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff3131",
    d: "M 75.09375 150 C 112.242188 150 142.46875 119.816406 142.46875 82.714844 C 142.46875 57.078125 127.546875 33.332031 104.453125 22.21875 C 100.84375 20.476562 96.492188 21.988281 94.75 25.605469 C 93.007812 29.214844 94.527344 33.554688 98.140625 35.292969 C 116.242188 44.003906 127.933594 62.621094 127.933594 82.714844 C 127.933594 111.8125 104.230469 135.484375 75.09375 135.484375 C 45.957031 135.484375 22.253906 111.8125 22.253906 82.714844 C 22.253906 62.621094 33.945312 44.003906 52.042969 35.292969 C 55.65625 33.554688 57.175781 29.214844 55.433594 25.605469 C 53.691406 21.992188 49.347656 20.476562 45.730469 22.21875 C 22.640625 33.332031 7.71875 57.082031 7.71875 82.714844 C 7.71875 119.816406 37.941406 150 75.09375 150 Z M 75.09375 150 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3131",
    d: "M 75.09375 51.386719 C 79.109375 51.386719 82.363281 48.140625 82.363281 44.128906 L 82.363281 7.257812 C 82.363281 3.25 79.109375 0 75.09375 0 C 71.078125 0 67.824219 3.25 67.824219 7.257812 L 67.824219 44.128906 C 67.824219 48.140625 71.078125 51.386719 75.09375 51.386719 Z M 75.09375 51.386719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.15ac6ed3fa75f73f33c842fe1b58998e.svg";
export { ForwardRef as ReactComponent };